import styled from 'styled-components'
import Image from 'common/image'
import { useTranslation } from 'react-i18next'
import { adobeInteractionEvent } from 'utils/adobewa'

const HowToJoinContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 359px;
    height: 650px;
    margin-top: 24px;
    margin-bottom: 80px;
`

const BoxContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 32px 20px;
    align-items: center;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 81px;
`

const TitleText = styled.div`
    color: var(--Brand-Color-Black, #121b21);
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px; /* 125% */
`

const TitleUnderLine = styled.div`
    margin-top: 16px;
    width: 80px;
    height: 5px;
    background: #d9c277;
`

const DisclaimerText = styled.div`
    margin-top: 32px;
    color: #003c84;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`

const DescriptionText = styled.div`
    margin-top: 16px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
`
const JoinUsButton = styled.div`
    margin-top: 32px;
    width: 296px;
    display: flex;
    min-height: 55px;
    padding: 8px 48px;
    justify-content: center;
    align-items: center;
    border-radius: 200px;
    background: #c5924d;
    cursor: pointer;
`

const JoinUsText = styled.div`
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

export default function HowToJoin() {
    const { t, i18n } = useTranslation('', { keyPrefix: 'earnwins.howtojoin' })
    const lang = i18n.language

    const howToJoinButtonClick = (url: string) => {
        window.open(url, '_blank')?.focus()
        adobeInteractionEvent({
            lang: lang,
            eventID: `prioritysite_click_EarnWins_JoinProgram_Tutorial`,
        })
    }

    return (
        <HowToJoinContainer>
            <BoxContainer>
                <TitleContainer>
                    <TitleText>{t('title')}</TitleText>
                    <TitleUnderLine />
                </TitleContainer>
                <Image
                    src={t('picture')}
                    width={316}
                    height={193}
                    style={{
                        borderRadius: '25px',
                        marginTop: '32px',
                    }}
                    alt="How To Join banner"
                />
                <DisclaimerText>{t('disclaimer')}</DisclaimerText>
                <DescriptionText>{t('content')}</DescriptionText>
                <JoinUsButton>
                    <JoinUsText
                        onClick={() => howToJoinButtonClick(t(`buttonUrl`))}
                    >
                        {t('buttonText')}
                    </JoinUsText>
                </JoinUsButton>
            </BoxContainer>
        </HowToJoinContainer>
    )
}
